import React from 'react';
import ReactDom from 'react-dom';

import { observable, action, computed } from 'mobx';
import { observer } from 'mobx-react';

import deepBind from 'deep-bind-decorator';

import BaseComponent from 'base-component';
import BaseContentModel from 'base-contentmodel';

import GraphComponent from './component';


export class GraphDataSetContentModel extends BaseContentModel {

  static _slots = {
    values: "",
    label: "",
    color: "",
    graphType: "",
  }

  static get _defaults() {
    return {
    }
  }

  @observable @deepBind _options = {
    get graphType() {
      return ["bar", "line", "spline", "step", "area", "area-spline", "area-step", "pie", "donut"];
    }
  }


  @observable values = "(Comma separated values or db variables names)";
  @observable label = "Dataset Label";
  @observable color = "auto or #990000";
  @observable graphType = "";
}

export class GraphContentModel extends BaseContentModel {

  static _slots = {
    title: "",
    datasets: [GraphDataSetContentModel],
    yLabel: "",
    yMin: "",
    yMax: "",
    yTickFormat: "",
    xTickLabels: "",
    showLegend: true,
    showTooltip: true,
    forceWidth: "",
    forceHeight: "",
    css: "",
  }

  static get _defaults() {
    return {
    }
  }

  Component = GraphComponent;

  @observable title = "Graph Title";
  @observable.shallow datasets = [];
  @observable yLabel = "Y-Axis Label";
  @observable yMin = -1;
  @observable yMax = -1;
  @observable yTickFormat = "numeral.js format";
  @observable xTickLabels = "Comma separated values";
  @observable showLegend = true;
  @observable showTooltip = true;
  @observable forceWidth = -1;
  @observable forceHeight = -1;
  @observable css = "";

  @computed get variables() {

    let vars = {};
    for (let i = 0; i < this.datasets.length; ++i) {

      const splitValues = this.datasets[i].values.split(",");
      for (let j = 0; j < splitValues.length; ++j) {
        let value = splitValues[j].trim();
        if (value.indexOf("G:") == 0) {
          if (value.indexOf(":-1") >= 0) {
            value = value.replace(":-1", ":" + (window.application.dataModel.domainStore.context.team.num5 - 1));
          }
          else if (value.indexOf(":+0") >= 0) {
            value = value.replace(":+0", ":" + (window.application.dataModel.domainStore.context.team.num5));
          }
          vars[value] = 0;
        }
      }
    }
    return vars;
  }

}

export default GraphContentModel



// WEBPACK FOOTER //
// ./app_modules/graph-activity/src/contentmodel.js